import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMobileFriendsActive = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_62414_236526)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M16.875 2.64625C17.843 2.89409 18.7009 3.45704 19.3136 4.24635C19.9263 5.03566 20.2588 6.00643 20.2588 7.00563C20.2588 8.00482 19.9263 8.97559 19.3136 9.7649C18.7009 10.5542 17.843 11.1172 16.875 11.365M23 22V19.2361C23 19.0808 22.9657 18.9267 22.8859 18.7935C22.4601 18.0823 21.4487 16.9043 20 16.18",
				stroke: "#2667FF",
				strokeWidth: 1.9,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 9,
				cy: 7,
				r: 4.5,
				fill: "#2667FF",
				stroke: "#2667FF",
				strokeWidth: 1.9
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17 19.2361V22H1V19.2361C1 19.0808 1.03368 18.9278 1.11209 18.7938C1.92161 17.4105 4.43632 15 9 15C13.5637 15 16.0784 17.4105 16.8879 18.7938C16.9663 18.9278 17 19.0808 17 19.2361Z",
				fill: "#2667FF",
				stroke: "#2667FF",
				strokeWidth: 1.9,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_62414_236526",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgMobileFriendsActive;
